import React from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  TrophyOutlined,
  FileSearchOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
  FileTextOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import { RejectionReason } from "../Entities/job-application.entity";

export interface StatusConfig {
  color: string;
  icon: React.ReactNode;
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  applied: { color: "processing", icon: <ClockCircleOutlined /> },
  shortlisted: { color: "purple", icon: <CheckCircleOutlined /> },
  interview: { color: "purple", icon: <SafetyOutlined /> },
  hired: { color: "success", icon: <TrophyOutlined /> },
  rejected: { color: "error", icon: <CloseCircleOutlined /> },
  accepted: { color: "success", icon: <CheckCircleOutlined /> },
};

export const getStatusConfig = (status: string): StatusConfig => {
  return STATUS_CONFIG[status] || STATUS_CONFIG.applied;
};

export interface RejectionReasonConfig {
  label: string;
  tip: string;
  icon: React.ReactNode;
}

export const REJECTION_REASON_CONFIG: Record<
  RejectionReason | "unknown",
  RejectionReasonConfig
> = {
  profile_match_failure: {
    label: "Profile Mismatch",
    tip: "Tailor your resume to highlight skills mentioned in job descriptions",
    icon: <UserOutlined />,
  },
  ai_assessment_failure: {
    label: "Assessment Not Passed",
    tip: "Practice similar assessments and take your time reviewing answers",
    icon: <FileSearchOutlined />,
  },
  ai_assessment_violation: {
    label: "Assessment Violation",
    tip: "Ensure stable internet, don't switch tabs, and stay in fullscreen mode",
    icon: <ExclamationCircleOutlined />,
  },
  marked_by_recruiter: {
    label: "Recruiter Decision",
    tip: "This could be due to competition or specific team requirements",
    icon: <CloseCircleOutlined />,
  },
  unknown: {
    label: "Not Specified",
    tip: "Keep improving your profile and assessment skills",
    icon: <ClockCircleOutlined />,
  },
};

// Analytics calculation constants
export const ANALYTICS_CONSTANTS = {
  // Score trend thresholds
  SCORE_TREND_IMPROVING_THRESHOLD: 5,
  SCORE_TREND_DECLINING_THRESHOLD: -5,
  
  // Recommendation thresholds
  PROFILE_MATCH_RATE_THRESHOLD: 50,
  ASSESSMENT_RATE_THRESHOLD: 50,
  MIN_APPLICATIONS_FOR_RECOMMENDATIONS: 3,
  
  // Funnel drop-off threshold
  BIGGEST_DROPOFF_THRESHOLD: 30,
  
  // Recent applications limit
  RECENT_APPLICATIONS_LIMIT: 10,
  
  // Recent scores limit
  RECENT_SCORES_LIMIT: 5,
  
  // Minimum scores for trend analysis
  MIN_SCORES_FOR_TREND: 3,
  
  // Score thresholds for tags
  HIGH_SCORE_THRESHOLD: 70,
  MEDIUM_SCORE_THRESHOLD: 50,
} as const;
